// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\BerthRelevance\ApiBerthRelevance.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Berth, BerthData, BerthOptions } from 'data/models/Berth';
import { Event, EventData, EventOptions } from 'data/models/Event';

// BerthRelevanceData is the class that BerthRelevance serializes to/from
export interface BerthRelevanceData {
    BerthId : number;
    EventId : number;
	
    Berth : BerthData | null;
    Event : EventData | null;
	
}

// BerthRelevanceOptions is the class which may be passed to the BerthRelevance constructor to define optional initial data values
export interface BerthRelevanceOptions {
    BerthId : number;
    EventId : number;
	
    Berth? : BerthOptions | null;
    Event? : EventOptions | null;
	
}

export class BerthRelevance {
    public BerthId : DataSignal<number>;
    public EventId : DataSignal<number>;
	
    public Berth : DataSignal<Berth | null>;
    public Event : DataSignal<Event | null>;
	

    constructor();
    constructor(data : BerthRelevanceOptions);
    constructor(data: BerthRelevanceOptions | null = null) {
        this.BerthId = jsonableObservable(S.value<number>(data && data.BerthId !== undefined ? data.BerthId : 0));
        this.EventId = jsonableObservable(S.value<number>(data && data.EventId !== undefined ? data.EventId : 0));
	    
        this.Berth = S.value<Berth | null>(null);
        this.Event = S.value<Event | null>(null);
	    
    }

    static key(obj : BerthRelevance) {
        return obj.BerthId() + '\u2618' + obj.EventId();
    }
    
    static dataKey(obj : BerthRelevanceOptions) {
        return obj.BerthId + '\u2618' + obj.EventId;
    }

    static update(obj : BerthRelevance, data : BerthRelevanceOptions) {
        S.freeze(() => {
            if (data.BerthId !== undefined) obj.BerthId(data.BerthId);
            if (data.EventId !== undefined) obj.EventId(data.EventId);
	        
	        
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/BerthRelevance.ts